import { useEffect, useState } from "react";

import { getViewportMode } from "../service/mySqlQueryListService";
import type { ViewportMode } from "../types";

/** 监听窗口尺寸并返回视口模式。 */
export function useViewportMode(): ViewportMode {
  const [viewportMode, setViewportMode] = useState<ViewportMode>(() =>
    typeof window !== "undefined" ? getViewportMode(window.innerWidth) : "desktop",
  );

  useEffect(() => {
    const handleResize = () => {
      setViewportMode(getViewportMode(window.innerWidth));
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return viewportMode;
}
